export default __webpack_public_path__ + "static/media/fragrant-cinnamon.173d6425.png";